module.exports = __webpack_public_path__ + "img/btn.4354fcf6.png";